export default "__VITE_ASSET__86NV3l7Z__"